export default __webpack_public_path__ + "5c25eeeec8671ec1c25db6df1efe33d0.png";